export const FASTER_FUNDING_STORAGE_KEY = "fasterFundingModalSeen";

const FasterFunding = ({ closeModal }: { closeModal: () => void }) => {
  const handleClose = () => {
    localStorage.setItem(FASTER_FUNDING_STORAGE_KEY, "true");
    closeModal();
  };

  return (
    <div className="flex flex-col items-center gap-4 py-2 text-center">
      <span className="text-5xl">⚡</span>

      <h2 className="text-dark-text-50 text-xl leading-snug font-bold">
        Faster Card Funding Has Arrived!
      </h2>

      <p className="text-dark-text-50/80 text-sm leading-relaxed">
        We&apos;ve upgraded our card funding infrastructure, meaning you can now
        add funds to your card in a fraction of the time. 🚀
      </p>

      <p className="text-dark-text-50/80 text-sm leading-relaxed">
        Perfect for those last-minute top-ups at the checkout, petrol station,
        or on the go. 💳🧃🛍️
      </p>

      <p className="text-dark-text-50/80 text-sm leading-relaxed">
        Less waiting. More spending. Enjoy the faster Dynascent Coin experience.
      </p>

      <button
        onClick={handleClose}
        className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-main/80 mt-2 w-full rounded-xl py-3 text-sm font-semibold transition-colors"
      >
        Close
      </button>
    </div>
  );
};

export default FasterFunding;
